import React from 'react';
import { Badge } from '../ui/badge';
import { CheckCircle, Warning } from '@phosphor-icons/react';

/**
 * Small badge showing billable / non-billable status.
 * Billable status is derived from code structure if not explicitly provided
 * (ICD-10 codes with 4+ alphanumeric chars are typically billable).
 */
const BillableBadge = ({ code, billable, compact = false }) => {
  const isBillable =
    billable !== undefined ? billable : code && code.replace('.', '').length > 3;

  if (compact) {
    return isBillable ? (
      <CheckCircle size={16} weight="fill" className="text-emerald-500 shrink-0" />
    ) : (
      <Warning size={16} weight="fill" className="text-amber-500 shrink-0" />
    );
  }

  return (
    <Badge
      variant="outline"
      className={`text-xs shrink-0 ${
        isBillable
          ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
          : 'bg-amber-50 text-amber-700 border-amber-200'
      }`}
    >
      {isBillable ? 'Billable' : 'Non-billable'}
    </Badge>
  );
};

export default BillableBadge;
